import { useOutletContext } from 'react-router-dom'
import { RegraCalculoPresenter } from 'service/api'

export function useRegrasCalculoContext() {
    return useOutletContext<{
        data: RegraCalculoPresenter[]
    }>()
}
